<style lang="less">
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list" style="margin-top:25px">
            <div class="table-list-title">
                <span style="margin-left:25px">个人实名</span>
            </div>
            <p style="color: red;font-size: 15px; margin-left: 36px" v-if="obligeeRealNameStatus == 'reject_real_name'">驳回原因：{{auditReason}}</p>
            <div class="personal_authentication_main">
                <ul class="main_group">
                    <li class="main_item">
                        <span class="item_title">证件类型：</span>
                        <div class="item_content"><span class="selection_box">身份证证件照认证</span></div>
                    </li>
                    <li class="main_item">
                        <span class="item_title top_title">上传证件：</span>
                        <div class="item_content">
                            <div class="upload_group">
                                <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="frontalRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :before-upload="frontalUpLoadBefore"
                                        :on-success="frontalUpLoadSuccess"
                                        :on-error="frontalUpLoadError"
                                        :on-exceeded-size="frontalExceededSize"
                                        :max-size="5120"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">

                                    <!--  没有图片时  -->
                                    <div v-if="frontalState == -1" class="upload_text">
                                        <!-- <div class="upload_text_add">+</div>
                                        <p>上传正面1</p> -->
                                        <img src='./images/Z.png'/>
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="frontalState == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="frontalState == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="frontalPhoto"
                                             alt='版权登记'>
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>
                                </Upload>
                                <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="reverseRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :before-upload="reverseUpLoadBefore"
                                        :on-success="reverseUpLoadSuccess"
                                        :on-error="reverseUpLoadError"
                                        :on-exceeded-size="reverseExceededSize"
                                        :max-size="5120"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">
                                    <!--  没有图片时  -->
                                    <div v-if="reverseState == -1" class="upload_text">
                                        <img src='./images/F.png'/>
                                        <!-- <div class="upload_text_add">+</div>
                                        <p>上传反面</p> -->
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="reverseState == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="reverseState == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="reversePhoto"
                                             alt='版权登记'>
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>

                                </Upload>
                                <div class="upload_desc">
                                    <div>上传证件要求：</div>
                                    <ul class="upload_desc_group">
                                        <li>1、上传的证件内容必须清晰可见</li>
                                        <li>2、作者名称和证件号码与提交的证件信息一致</li>
                                        <li>3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨</li>
                                        <li>4、须小于5MB，且为JPG格式，尺寸过小不宜上传(推荐800*600以上）</li>
                                        <li>5、证件在有效期之内</li>
                                    </ul>
                                    <div class="demo_img">
                                        <img src="./images/upload_demo.png" alt='版权登记'>
                                        <ol class="demo_text">
                                            <li>标准</li>
                                            <li style="padding-left: 12px;">边框缺失</li>
                                            <li>照片模糊</li>
                                            <li>闪光强烈</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">姓名：</span>
                        <div class="item_content">
                            <i-input v-model="modifyUserName" placeholder="请输入姓名"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">证件号：</span>
                        <div class="item_content">
                            <i-input v-model="modifyIdCardNum" placeholder="请输入证件号"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">国家省市：</span>
                        <div class="item_content" style="color: #CBCBCB;">
                            <Select class="item_city_list" v-model="countrySelection">
                                <Option :value="countrySelection">{{countrySelection}}</Option>
                            </Select>
                            —
                            <Select class="item_city_list" v-model="provincesSelection" @on-change="provinceChange">
                                <Option v-for="(item,index) in cityData" :value="index">{{index}}</Option>
                            </Select>
                            —
                            <Select class="item_city_list" v-model="citySelection">
                                <Option v-for="(item,index) in cityData[provincesSelection]" :value="item">{{item}}
                                </Option>
                            </Select>

                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">详细地址：</span>
                        <div class="item_content">
                            <i-input v-model="detailedAddress" maxlength="100" placeholder="请输入详细地址"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">证件有效期：</span>
                        <div class="item_content">
                            <DatePicker class="item_date_list" style="width: 165px;" type="date" placeholder="开始时间"
                                        :value="startTime"
                                        format="yyyy-MM-dd"
                                        @on-change="startTimeChange"
                                        :options="disabledDate[0].start"></DatePicker>
                            <Select v-model="dateTypeValue" @on-change="dateTypeChange" class="item_date_list"
                                    style="width: 175px;height: 48px;">
                                <Option v-for="(item,index) in dateType" :value="item.value">{{item.label}}</Option>
                            </Select>
                            <DatePicker v-show="dateTypeValue!=0" class="item_date_list" style="width: 165px;"
                                        type="date"
                                        :value="dateTypeValue == 0? endTime='长期' : endTime "
                                        placeholder="结束时间"
                                        format="yyyy-MM-dd"
                                        @on-change="endTimeChange"
                                        :options="disabledDate[1].end"></DatePicker>
                        </div>
                    </li>
                </ul>
            </div>
            <div style="padding: 30px 0;text-align: center">
                <div class="submit_btn" @click="checkSubmit">认证</div>
            </div>

        </div>
    </div>

</template>

<script>
    import {_getProvinceAndCityList, _getpersonRealName, _findMainObligee, _findById} from "@/api/authentication.js";
    import {userInfo} from "@/api/index";
    import Cookies from "js-cookie";


    export default {
        metaInfo: {
            title: '个人认证|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '个人认证,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "personalAuthentication",
        data() {
            return {
                obligeeRealNameStatus: '',
                auditReason: '',
                poId: '',
                saveLogin: false, //重置用户是否自动保存
                getId: '', //获取页面上传递的id
                userName: '', //姓名
                modifyUserName: '', //修改后的姓名
                idCardNum: '', //身份证号
                modifyIdCardNum: '', //修改后的身份证号
                frontalRequestData: {picType: 'idCadeOn'}, //上传身份证正面请求参数
                reverseRequestData: {picType: 'idCadeBack'}, //上传身份证正面请求参数
                frontalFileId: '', //身份证正面照片id
                reverseFileId: '', //身份证反面照片id
                frontalPhoto: '', //身份证正面照片
                reversePhoto: '', //身份证反面照片
                frontalState: -1, //正面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                reverseState: -1, //反面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                cityData: [], //省份城市列表
                countrySelection: '中国', //选中国家
                provincesSelection: '北京', //选中省份
                citySelection: '北京', //选中城市
                detailedAddress: '', //详细地址
                disabledDate: [
                    {
                        start: {
                            disabledDate(date) {
                                return date && date.valueOf() > Date.now() - 172800;
                            }
                        }
                    },
                    {
                        end: {
                            disabledDate(date) {
                                return date && date.valueOf() < Date.now() - 8.64e7;
                            }
                        }
                    }
                ], //时间限制条件
                dateType: [
                    {value: 0, label: '无期限'},
                    {value: 1, label: '有期限（请选择日期）'},
                ], //时间下拉框选项
                dateTypeValue: 0, //当前时间选择值
                startTime: '', //证件开始时间
                endTime: '', //证件结束时间
                btnFlag: true, //防止重复点击


            }
        },
        beforeCreate() {
            // console.log(JSON.parse(Cookies.get("userInfo")))

        },
        created() {
            this.getProvinceAndCityList();
            if (this.$route.query.id && this.$route.query.id != '') {
                this.getId = this.$route.query.id;
                this.findById(this.getId);
            }
        },
        methods: {
            /****************身份证正面**************/
            frontalUpLoadBefore() {
                this.frontalState = 1;
            },
            frontalUpLoadSuccess(res) {
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.userName = result.name;
                    this.modifyUserName = result.name;
                    this.frontalFileId = res.fileId;
                    this.frontalPhoto = res.fileUrl;
                    this.idCardNum = result.id;
                    this.modifyIdCardNum = result.id;
                    this.detailedAddress = result.address;
                    this.frontalState = 0;
                } else {
                    this.frontalUpLoadError();
                }
            },
            frontalExceededSize() {
                toast('证件大小不得超过5MB');
                this.frontalUpLoadError(true);
            },
            frontalUpLoadError(showToast) {
                this.frontalFileId = '';
                this.frontalState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },

            /****************身份证反面**************/
            reverseUpLoadBefore() {
                this.reverseState = 1;
            },
            reverseUpLoadSuccess(res) {
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.reversePhoto = res.fileUrl;
                    this.reverseFileId = res.fileId;
                    this.startTime = result.validStart;
                    if (result.validEnd != '长期') {
                        this.endTime = result.validEnd;
                        this.dateTypeValue = 1;
                    } else {
                        this.dateTypeValue = 0;
                    }
                    this.reverseState = 0;
                } else {
                    this.reverseUpLoadError();
                }
            },
            reverseExceededSize() {
                toast('证件大小不得超过5MB');
                this.reverseUpLoadError(true);
            },
            reverseUpLoadError(showToast) {
                this.reverseFileId = '';
                this.reverseState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },


            /****************获取省市列表接口数据**************/
            getProvinceAndCityList() {
                _getProvinceAndCityList().then(res => {
                    if (res) {
                        this.cityData = res;
                    }
                });

            },
            provinceChange(value) {
                this.citySelection = this.cityData[value][0];
            },

            /****************证件有效期开始时间**************/
            startTimeChange(value) {
                this.startTime = value;
            },

            /****************证件有效期结束时间**************/
            endTimeChange(value) {
                this.endTime = value;
            },

            /****************证件是否长期有效的改变事件**************/
            dateTypeChange(value) {
                this.endTime = '';
            },


            /****************获取相对应的认证信息**************/
            /*findMainObligee() {
              _findMainObligee().then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        let result = res.result;
                        let endTime = result.attachEndTime;

                        this.frontalFileId = result.attachment1;
                        this.frontalPhoto = result.attachment1Url;
                        this.frontalState = 0;
                        this.reverseFileId = result.attachment2;
                        this.reversePhoto = result.attachment2Url;
                        this.reverseState = 0;
                        this.userName = result.name;
                        this.modifyUserName = result.name;
                        this.idCardNum = result.identityNumber;
                        this.modifyIdCardNum = result.identityNumber;
                        this.detailedAddress = result.address;
                        this.startTime = result.attachStartTime;
                        this.poId = result.id;

                        if (endTime != '长期') {
                            this.dateTypeValue = 1;
                            this.endTime = endTime;
                        }
                    }
                })
            },*/

          findById(poId) {
            _findById(poId).then(res => {
              console.log(res);
              if (res.code == 200) {
                let result = res.result;
                let endTime = result.attachEndTime;
                this.auditReason = result.auditReason;
                this.obligeeRealNameStatus = result.obligeeRealNameStatus;
                this.frontalFileId = result.attachment1;
                this.frontalPhoto = result.attachment1Url;
                this.frontalState = 0;
                this.reverseFileId = result.attachment2;
                this.reversePhoto = result.attachment2Url;
                this.reverseState = 0;
                this.userName = result.name;
                this.modifyUserName = result.name;
                this.idCardNum = result.identityNumber;
                this.modifyIdCardNum = result.identityNumber;
                this.detailedAddress = result.address;
                this.startTime = result.attachStartTime;
                this.poId = result.id;

                if (endTime != '长期') {
                  this.dateTypeValue = 1;
                  this.endTime = endTime;
                }
              }
            })
          },

            /****************提交认证**************/
            checkSubmit() {
                if(!this.btnFlag){
                    return
                }
                if (this.modifyUserName != '' && this.modifyIdCardNum != '' && this.frontalFileId != '' && this.reverseFileId != '' && this.provincesSelection != '' && this.citySelection != '' && this.detailedAddress != '' && this.startTime != '' && this.endTime != '') {
                    this.btnFlag = false;

                    let _userInfo = JSON.parse(Cookies.get("userInfo"));
                    let data = {
                        poId: this.poId,
                        identityType: 1,
                        authMethod: 'idcard',
                        name: this.userName,
                        modifyName: this.modifyUserName,
                        identityNo: this.idCardNum,
                        modifyIdentityNo: this.modifyIdCardNum,
                        country: this.countrySelection,
                        province: this.provincesSelection,
                        city: this.citySelection,
                        address: this.detailedAddress,
                        registerId: _userInfo.id,
                        attachment1: this.frontalFileId,
                        attachment1Uuid: this.frontalFileId,
                        attachment2: this.reverseFileId,
                        attachment2Uuid: this.reverseFileId,
                        attachStartTime: this.startTime,
                        attachEndTime: this.endTime
                    };

                    _getpersonRealName(data).then(res => {
                        console.log(res);
                        if (res.code == 200) {

                            // 获取用户信息
                            userInfo().then(res => {
                                if (res.code == 200) {
                                    toast('认证成功');

                                    // 避免超过大小限制
                                    if (this.saveLogin) {
                                        // 保存7天
                                        Cookies.set("userInfo", JSON.stringify(res.result), {
                                            expires: 7
                                        });
                                    } else {
                                        Cookies.set("userInfo", JSON.stringify(res.result));
                                    }
                                    this.setStore("userInfo", res.result);
                                    let photo = res.result.photo ? res.result.photo : '';
                                    this.$store.commit("setAvatarPath", photo);
                                    this.$router.push("/obligee");
                                } else {
                                    toast('认证失败，请重试');
                                }
                            }, err => {

                            });


                        } else {
                            toast(res.message);
                        }
                        this.btnFlag = true;
                    }, (err) => {
                        console.log(err);
                        this.btnFlag = true;

                    });
                } else {
                    toast('请填写完整后再提交');
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .center-table-list .table-list {
        height: 100%;
    }

    .main_group .main_item {
        display: flex;
        border-bottom: 1px solid #F3F3F3;
        padding: 20px 35px;
        color: #666;
        font-size: 14px;
    }

    .main_item .item_title {
        width: 130px;
        align-self: center;
    }

    .main_item .item_title.top_title {
        align-self: auto;
    }

    .main_item .item_content {
        flex: 1;
    }

    .item_content .selection_box:before {
        content: '';
        width: 12px;
        height: 12px;
        background: #FFD800;
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
        margin-top: -3px;
    }

    .upload_group .upload_desc {
        padding-top: 15px;
        color: #999999;
        font-size: 12px;
        line-height: 17px;
    }

    .upload_desc .demo_img {
        width: 327px;
        padding-top: 14px;
    }

    .upload_desc .demo_text {
        width: 335px;
        color: #666666;
        font-size: 12px;
        font-weight: bold;
        padding-top: 4px;
        display: flex;
        justify-content: space-around;
        list-style: none;
    }

    .demo_img img {
        display: block;
        width: 100%;
        height: 48px;
    }

    .upload_desc .upload_desc_group {
        list-style: none;
        padding-top: 5px;
    }

    /deep/ .ivu-input {
        width: 400px;
        height: 48px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 14px;
        line-height: 48px;
        color: #333;
        padding: 0 10px;
    }

    /deep/ .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
        color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
        color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
        color: #999999;
    }


    .myu_upload {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-top: 10px;
        }
    }


    /deep/ .ivu-upload {
        width: 180px;
        height: 110px;
        margin-right: 20px;
        display: flex;
    }

    /deep/ .ivu-upload-drag {
        border: 1px solid #CBCBCB;
    }

    .upload_text {
        align-self: center;
        margin: 0 auto;
        color: #999;
        font-size: 12px;
        img{
            width: 162px;
            height: 81px;
            display: block;
            margin: auto;
        }
    }

    .upload_ing {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
    }

    .upload_ing .upload_ing_text {
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .upload_success {
        position: relative;
        width: 100%;
    }

    .upload_success .upload_success_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .upload_success:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 2;
    }

    .upload_success .upload_success_btn {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background: rgba(255, 216, 0, 1);
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        color: #4E4E4E;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 3;
        font-size: 14px;
        margin: -13px 0 0 -41px;
        transition: .3s ease-out;
    }

    .upload_success .upload_success_btn:hover {
        color: #fff;
        background-color: #cf7700;
        border-color: #cf7700;
    }

    .upload_text .upload_text_add {
        color: #A9A9A9;
        font-size: 40px;
        line-height: 1;
        margin-bottom: 9px;
    }

    /deep/ .ivu-date-picker .ivu-input {
        width: 100%;
    }

    /deep/ .item_date_list .ivu-input-suffix i {
        line-height: 48px;
    }

    .item_content .item_date_list {
        margin-right: 30px;
    }

    .item_content .item_date_list:last-child {
        margin-right: 0;
    }

    .item_content .item_city_list {
        width: 140px;
        height: 32px;
        /*margin-right: 35px;*/
    }

    .item_content .item_city_list:last-child {
        margin-right: 0;
    }

    /deep/ .item_city_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        text-align: center;
        color: #333333;
    }


    /deep/ .item_date_list.ivu-select-single .ivu-select-selection {
        height: 48px;
        border-radius: 2px;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
        height: 48px;
        line-height: 48px;
        color: #999999;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 48px;
        line-height: 48px;
    }

    .submit_btn {
        width: 230px;
        height: 42px;
        line-height: 42px;
        background: #FFD800;
        color: #4E4E4E;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        display: inline-block;
        border-radius: 4px;
        cursor: pointer;
    }


</style>
